import { META_INFO } from 'constants/meta';
import {
  AboutUs,
  CustomerManager,
  Features,
  OnlineStore,
  HelpCenter,
  Home,
  Legal,
  SimpleIntegration,
  Templates,
  WebsiteBuilder,
} from '../pages';

export const MODAL_ROUTES = [
  '/login',
  '/login/recovery',
  '/login/success',
  '/password-reset',
];

const Routes = [
  {
    path: '/',
    exact: true,
    Page: Home,
    withBanner: true,
    title: META_INFO['/'].title,
    description: META_INFO['/'].description,
  },
  {
    path: '/legal',
    Page: Legal,
  },
  {
    path: '/website-builder',
    Page: WebsiteBuilder,
    withBanner: true,
    title: META_INFO['/website-builder'].title,
    description: META_INFO['/website-builder'].description,
  },
  {
    path: '/simple-integration',
    Page: SimpleIntegration,
    withBanner: true,
    title: META_INFO['/simple-integration'].title,
    description: META_INFO['/simple-integration'].description,
  },
  {
    path: '/online-store',
    Page: OnlineStore,
    withBanner: true,
    title: META_INFO['/online-store'].title,
    description: META_INFO['/online-store'].description,
  },
  {
    path: '/customer-manager',
    Page: CustomerManager,
    withBanner: true,
    title: META_INFO['/customer-manager'].title,
    description: META_INFO['/customer-manager'].description,
  },
  {
    path: '/features',
    Page: Features,
    withBanner: true,
    title: META_INFO['/features'].title,
    description: META_INFO['/features'].description,
  },
  {
    path: '/templates',
    Page: Templates,
    withBanner: true,
    title: META_INFO['/templates'].title,
    description: META_INFO['/templates'].description,
  },
  {
    path: '/about-us',
    Page: AboutUs,
    title: META_INFO['/about-us'].title,
    description: META_INFO['/about-us'].description,
  },
  // {
  //   path: '/register',
  //   Page: Registration,
  //   title: META_INFO['/register'].title,
  //   description: META_INFO['/register'].description,
  // },
  /* {
    path: '/contact',
    Page: Contact,
    title: META_INFO['/contact'].title,
    description: META_INFO['/contact'].description,
  }, */
  // {
  //   path: '/checkout',
  //   Page: Checkout,
  //   title: META_INFO['/checkout'].title,
  //   description: META_INFO['/checkout'].description,
  // },
  {
    path: '/help',
    Page: HelpCenter,
    title: META_INFO['/help'].title,
    description: META_INFO['/help'].description,
  },
];

export default Routes;
